import React, { useContext, useEffect, useState } from "react";
import s from "./footer.module.css";
import sNav from "./mainMenu.module.css";
import { Link } from "react-scroll";

import Logo from "./Logo";
import { NavContext } from "../context/NavState";
import { TextContext } from "../context/TextContext";

const Footer = () => {
  const { navigation } = useContext(NavContext);
  const { data: setting } = useContext(TextContext);

  const [workTime, setWorkTime] = useState("c 9:00 до 18:00");
  useEffect(() => {
    setWorkTime(setting.workTime);
  }, [setting.workTime]);
  const getUrl = (url: string) => (url ? process.env.REACT_APP_API + url : "");
  return (
    <div className={s.container}>
      <div className={s.inner}>
        <div id={s.logo} className={sNav.logo_box}>
          <Logo />
        </div>
        <div className={s.document_box}>
          <a
            target="_blank"
            rel="noreferrer"
            href={getUrl(setting.policyConf?.url)}
            className={s.document_text}
          >
            Политика конфиденциальности
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={getUrl(setting.contract?.url)}
            className={s.document_text}
          >
            Договор оферты
          </a>
        </div>
        <div className={s.middle_box}>
          <div className={s.nav_box}>
            <div className={s.anchors_box}>
              {navigation.map((link, i) => (
                <Link
                  className={sNav.item_anchor}
                  key={i}
                  to={link.to}
                  offset={-65}
                  smooth={true}
                  duration={800}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div id={s.phone} className={sNav.phone}>
          <div className={sNav.phoneIcon}>
            <svg
              width="45"
              height="45"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="36" height="36" rx="18" fill="#41CBDD" />
              <path
                d="M22.4333 19.6334C21.9634 19.1696 21.3769 19.1696 20.91 19.6334C20.5539 19.9865 20.1978 20.3396 19.8477 20.6987C19.7519 20.7975 19.6711 20.8184 19.5544 20.7526C19.324 20.6269 19.0786 20.5252 18.8572 20.3875C17.8247 19.7381 16.9599 18.9032 16.1938 17.9636C15.8137 17.4968 15.4756 16.997 15.2391 16.4344C15.1913 16.3207 15.2002 16.2459 15.293 16.1532C15.6491 15.809 15.9963 15.4559 16.3464 15.1028C16.8342 14.612 16.8342 14.0375 16.3434 13.5437C16.0651 13.2624 15.7868 12.9871 15.5085 12.7058C15.2212 12.4185 14.9369 12.1283 14.6466 11.844C14.1768 11.3861 13.5902 11.3861 13.1234 11.847C12.7643 12.2001 12.4202 12.5622 12.0551 12.9093C11.7169 13.2295 11.5463 13.6215 11.5104 14.0794C11.4536 14.8245 11.6361 15.5277 11.8935 16.213C12.4202 17.6314 13.2222 18.8913 14.1947 20.0464C15.5085 21.6084 17.0766 22.8443 18.911 23.7361C19.737 24.1371 20.5928 24.4453 21.5235 24.4962C22.1639 24.5321 22.7205 24.3705 23.1664 23.8708C23.4717 23.5296 23.8158 23.2184 24.139 22.8922C24.6178 22.4074 24.6208 21.8209 24.145 21.3421C23.5764 20.7705 23.0048 20.202 22.4333 19.6334Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div className={sNav.phoneInfo}>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                className={sNav.phoneLink}
                href={`tel:+${setting.phone ? setting.phone?.match(/\d+/g)?.join("") : "79775304925"}`}
              >
                {setting.phone ?? "+7(977) 530-49-25"}
              </a>
            </div>
            <div dangerouslySetInnerHTML={{ __html: workTime }}></div>
          </div>
        </div>
        <div id={s.wa} className={sNav.phone}>
          <div className={sNav.phoneIcon}>
            <svg
              width="45"
              height="45"
              viewBox="0 0 1000 1000"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#8AC44B"
                d="M473.1,10.44c-87.65,7.87 -161.69,33.57 -232.08,80.37c-119.49,79.59 -197.74,208.48 -212.89,350.42c-2.49,24.17 -2.49,79.02 0.19,102.8c5.95,55.43 22.44,111.44 47.95,163.03l12.66,25.89l-40.47,121.41c-38.94,117 -40.28,121.79 -37.6,126.78c1.73,2.88 5.18,6.52 8.06,8.06c4.6,2.68 13.04,0.77 137.33,-31.84l132.34,-34.91l21.67,9.78c105.3,46.99 225.17,55.05 335.46,22.44c127.16,-37.59 237.26,-130.81 295.37,-250.11c22.63,-46.22 36.06,-89.19 44.3,-140.97c5.18,-31.46 6.14,-100.7 2.11,-130.42c-12.85,-91.1 -48.14,-174.15 -103.57,-243.59c-75.38,-94.17 -187.2,-157.66 -310.14,-175.69c-18.79,-2.68 -83.62,-4.98 -100.69,-3.45Zm-83.154,233.077c9.95,4.37 18.243,10.705 30.905,23.516c14.47,14.777 22.463,25.026 37.688,48.095c13.267,20.2 16.883,29.851 15.979,42.812c-0.904,12.969 -4.677,18.392 -23.069,33.916c-13.715,11.459 -17.488,15.531 -21.41,23.367c-6.178,11.609 -6.484,19.296 -1.203,29.702c5.274,10.556 117.584,122.716 127.385,127.086c16.129,7.388 31.204,1.36 48.543,-19.146c20.655,-24.57 24.876,-27.439 40.549,-27.439c11.153,-0 20.805,3.773 38.293,15.224c23.367,15.225 38.592,27.439 53.965,43.418c17.033,17.787 22.763,28.948 22.763,44.621c-0,16.435 -4.52,24.719 -25.176,45.681c-20.954,21.253 -36.933,33.617 -54.57,41.909c-19.296,9.047 -31.204,11.609 -52.009,11.609c-37.837,-0.299 -74.016,-15.979 -118.338,-51.404c-12.206,-9.809 -150.901,-147.144 -172.304,-170.661c-32.107,-35.275 -53.368,-70.55 -61.503,-101.753c-5.125,-19.752 -5.431,-45.375 -0.904,-62.714c4.071,-15.075 12.969,-32.713 24.271,-47.489c11.609,-15.374 41.304,-44.471 49.596,-48.692c12.961,-6.634 27.887,-7.09 40.549,-1.658Z"
              />
            </svg>
          </div>
          <div className={sNav.phoneInfo}>
            <div>
              <a
                href={setting.whatsApp}
                className={sNav.phoneLink}
                rel="noreferrer"
                target="_blank"
              >
                Whatsapp
              </a>
            </div>
          </div>
        </div>
        <div id={s.mail} className={sNav.phone}>
          <a
            href={`mailto:${setting.email}`}
            target="_blank"
            rel="noreferrer"
            className={sNav.phoneLink}
            style={{ fontWeight: "400", fontSize: "16px" }}
          >
            {setting.email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
